module.exports = __webpack_public_path__ + "static/media/dips.f8f00788.png";